import { Col, Row, Select, Input } from 'antd';
import moment from "moment";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { renderPaymentTerms, renderPreferredTime, renderRowCurrency } from './../../../../../components/render-select';
import { preferredTime, needCollectAmountTerms } from './../../../../../constants';
import { convertDateFromUTC } from './../../../../../services/dst';
import { dateFormat } from './../../../../../services/ruleValidate';
import { ServiceType } from './../../../../../constants/index';
import './styles.css';

const Option = Select.Option

class ShipmentOptions extends Component {
    render() {
        const { shipment, shipperInformation } = this.props
        let listServiceType = Object.keys(ServiceType).map((key) => {
            return <Option value={key} key={key}>{ServiceType[key]}</Option>
        })
        var toViewCollectAmount = false;
        if(needCollectAmountTerms.includes(shipment.PaymentTermCH))
        {
            toViewCollectAmount = true;
        }
        return (
            <Col span={8} id="shipment-options">
                <Row gutter={16}>
                    <Col span={9} className="size-shipment-col-1">
                        <h1 className='title title-field'>SHIPMENT OPTIONS</h1>
                    </Col>
                    <Col span={15} className="size-shipment-col-2">
                        <div className="gutter-box">
                            <h3 className='title-field'>TERMS</h3>
                            <Select className="style-select"
                                value={shipment.PaymentTermCH}
                                disabled
                            >
                                {renderPaymentTerms(String(shipperInformation.paymentTerms), shipperInformation.defaultPaymentTerm, shipment.ChannelShortName, shipment.DestinationCountryCH)}
                            </Select>
                        </div>
                        <div className="gutter-box">
                            <h3 className='title-field'>SERVICE TYPE</h3>
                            <Select className="style-select"
                                value={shipment.KT_LabelTypeCH}
                                disabled
                            >
                                {listServiceType}
                            </Select>
                        </div>
                        <div className="gutter-box">
                            <h3 className='title-field'>PREFERRED DELIVERY TIME</h3>
                            <Select className="style-select"
                                value={shipment.DeliveryTimeCH}
                                disabled
                            >
                                {renderPreferredTime(preferredTime)}
                            </Select>
                        </div>
                        <div className="gutter-box">
                            <h3 className='title-field'>CURRENCY</h3>
                            <Select className="style-select"
                                value={shipment.CurrencyCH}
                                disabled
                            >
                                {renderRowCurrency()}
                            </Select>
                        </div>
                        {
                          shipperInformation.handlingChargeFlg?
                          <div className="gutter-box">
                          <h3 className='title-field'>HANDLING CHARGE</h3>
                          <Input
                              className="style-select"
                              value={shipment.HandlingCharge}
                              disabled
                          >
                          </Input>
                          </div>
                          :
                          ""
                        }
                        {
                            toViewCollectAmount ?
                            <div className="gutter-box">
                            <h3 className='title-field'>Collect Amount</h3>
                            <Input
                                className="style-select"
                                value={shipment.CollectAmount}
                                disabled
                            >
                            </Input>
                            </div>
                            : ""
                        }
                    </Col>
                </Row>
            </Col>
        );
    }
}

const mapStateToProps = state => {
    return {
        shipment: state.detailShipment.shipment,
        shipperInformation: state.detailShipment.shipperInformation,
    }
}

export default connect(mapStateToProps)(ShipmentOptions)



// WEBPACK FOOTER //
// ./src/containers/shipments/detail-shipment/components/shipment-options/index.js